<template>
    <div class="log-containers">
        <div v-if="data.length > 0">
            <p v-for="(item,index) in data"
               :key="index">
                <code class="show-log"
                      v-html="item"></code>
            </p>
        </div>
        <div v-else>
            <p class="log-nr">
                暂无日志
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'log',
    props: ['data'],
    methods: {
        getInfo (item) {
            const str = '找不到有效主机，原因是 。'
            item = item.replace(str, '找不到有效主机，请查看控制台')
            return item
        }
    }
}
</script>

<style lang="less" scoped>
.log-containers {
    position: relative;
    padding: 0px 10px 0px 10px;
    width: 100%;
    min-height: 320px;
    overflow: auto;
    background-color: #242424;
    padding: 0xp 10px;
    padding-bottom: 10px;
    color: white;
    font-size: 12px;
    font-family: "DejaVu Sans Mono", "Everson Mono", FreeMono, "Andale Mono",
        Consolas, monospace;
    p {
        margin-top: 10px;
        .show-log {
            padding: 0;
        }
    }
    p.log-nr {
        line-height: 300px;
        background-color: transparent;
        color: #ccc;
        text-align: center;
        font-size: 20px;
    }
}
</style>
